import React, { useContext } from "react";
import "../../assets/styles/edit-carousel.scss";
import SmuBadge from "../../utils/smu-badge/SmuBadge";
import SmuModal from "../../utils/smu-modal/SmuModal";
import { useState } from "react";
import SmuFileUploader from "../../utils/smu-file-uploader/SmuFileUploader";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import CarouselItem from "./parts/CarouselItem";
import { deleteFile, uploadFileByCategory } from "../../api/files";
import { StoreContext } from "../../store/StoreContext";
import { fetchBanners } from "../../api/banners";
import { toast } from "../../helpers/smu-alerts/smu-lerts";
import Swal from "sweetalert2";
import { COLOR_PRIMARY } from "../../constants/colors";
import { BANNER_CATEGORY } from "../../constants/categories";

const acceptedTypes = ["JPEG", "PNG", "JPG"];

const EditCarousel = ({ show, onHide }) => {
  const { banners, setBanners } = useContext(StoreContext);

  const [files, setFiles] = useState([]);

  const handleFetchBanners = () => {
    return fetchBanners().then(({ data, error }) => {
      if (!!error) return;
      setBanners(data.data.documents || []);
    });
  };

  const handleUploadFile = async () => {
    const result = await Promise.all(
      files.map((file) => {
        const metadata = { fileName: file.name };
        const formData = new FormData();
        formData.append("document", file, file.name);
        formData.append("category", BANNER_CATEGORY);
        formData.append("metadata", JSON.stringify(metadata));
        formData.append("is_public", true);
        formData.append("filetype", BANNER_CATEGORY);

        return uploadFileByCategory(formData);
      })
    );

    handleFetchBanners();
    return result;
  };

  const handleDelete = (uuid) => {
    Swal.fire({
      title: "¿Deseas eliminar este banner?",
      showCancelButton: true,
      confirmButtonText: "Eliminar",
      confirmButtonColor: COLOR_PRIMARY,
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (!result.isConfirmed) return;

      deleteFile(BANNER_CATEGORY, uuid)
        .then(({ error }) => {
          if (!!error) throw new Error(error?.message);
          toast({ icon: "success", title: "Banner eliminado." });
        })
        .catch((err) => {
          console.error(err);//toast({ icon: "error", title: err });
        })
        .finally(() => {
          handleFetchBanners();
        });
    });
  };

  return (
    <SmuModal
      show={show}
      onHide={onHide}
      contentTitle={
        <div className="d-flex">
          <SmuBadge color="#8E59FF" />
          <div className="ms-3 fs-5 text-truncate">Cargar Banner</div>
        </div>
      }
    >
      <SmuFileUploader
        uploadFile={handleUploadFile}
        acceptedTypes={acceptedTypes}
        files={files}
        setFiles={setFiles}
        multiple={true}
      />

      <div className="fs-6 my-5">Previsualización</div>

      <div className="carousel-preview">
        <Carousel
          autoPlay={false}
          infiniteLoop={false}
          showIndicators={false}
          showArrows={true}
          showThumbs={true}
          centerMode={true}
          showStatus={false}
          centerSlidePercentage={34}
        >
          {banners.map((banner) => (
            <CarouselItem
              key={banner.id}
              imageUrl={banner.url}
              handleDelete={() => handleDelete(banner.id)}
            />
          ))}
        </Carousel>
      </div>
    </SmuModal>
  );
};

export default EditCarousel;
